// extracted by mini-css-extract-plugin
export var footer = "_ps-5";
export var fulfillmentInput = "_ps-0";
export var shipDateInput = "_ps-1";
export var shipmentModal = "_ps-2";
export var shipmentModalContent = "_ps-3";
export var tableContainer = "_ps-4";